.discountBlock {
  position: relative;
  margin-top: 32px;
  margin-bottom: 32px;
  min-height: 84px;
  display: flex;
  padding: 20px 20px 20px 103px;
  border-radius: 24px;
  background: #f3eddf;
  margin-left: 20px;
  margin-right: 20px;

  p {
    color: #231e19;
    font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif;
    font-size: 17px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0.068px;
  }

  img {
    width: 87px;
    min-width: 87px;
    position: absolute;
    left: 7px;
    bottom: 5px;
  }
}

// Dark mode
:global body.dark {
  :local {
    .discountBlock {
      background-color: #2a2928;

      p {
        color: #fffbf2;
      }
    }
  }
}

:global body.dark #secondScreenWrapper {
  :local {
    .discountBlock {
      background-color: #181716;
    }
  }
}
